import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import middleware from "../../../Api/Middleware.js";
import ToastError from "../../../Toasts/ToastError.js";
import ToastSuccess from "../../../Toasts/ToastSuccess.js";
import { ButtonBlue } from "../../../HouseStyle/Components/Buttons.js";
import { BorderedTextInput } from "../../../HouseStyle/Components/Inputs.js";
import "../../../Modals/ModalStyle.css";

function GiftcardNewModal ({ show, setShow, onSuccess }) {
    const [cardNumber, setCardNumber] = useState('');
    const [loading, setLoading] = useState(false);

    const formatCardNumber = (num) => {
        if (!num) return '';
        const str = num.toString();
        if (str.length === 13) {
            return `${str[0]}-${str.slice(1, 7)}-${str.slice(7, 13)}`;
        }
        return str.match(/.{1,4}/g)?.join('-') || str;
    };

    const handleCardNumberChange = (value) => {
        const cleanValue = value.replace(/\D/g, '');
        const limitedValue = cleanValue.slice(0, 13);
        if (limitedValue.length === 13) {
            setCardNumber(formatCardNumber(limitedValue));
        } else {
            setCardNumber(limitedValue);
        }
    };

    const handleClose = () => {
        setCardNumber('');
        setShow(false);
    };

    const addNewGiftcard = async () => {
        const cleanCard = cardNumber.replace(/\D/g, '');
        if (cleanCard.trim() === '') {
            ToastError('Vul het kaartnummer in', 'enter_all_field_error');
            return;
        }
        
        setLoading(true);
        try {
            await middleware.post(`giftcards`, { 
                card_number: cleanCard,
                status: 1,
            });
            ToastSuccess('Cadeaukaart succesvol aangemaakt');
            handleClose();
            if (onSuccess) onSuccess();
        } catch (error) {
            console.error(error);
            ToastError('Fout bij het aanmaken');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal 
            show={show}
            onHide={handleClose}
            className="modalEditLabel"
            centered
            size="m"
        >
            <Modal.Header className="modalTop justify-content-between" closeButton>
                <Modal.Title>Cadeaukaart aanmaken</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modalCenter">
                <div 
                    className="d-flex flex-column gap-2"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !loading) {
                            addNewGiftcard();
                        }
                    }}
                >
                    <BorderedTextInput 
                        label="Kaartnummer" 
                        inputValue={cardNumber} 
                        setInputValue={handleCardNumberChange} 
                        placeholder='Kaartnummer' 
                        size='m'
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className="modalBottom">
                <ButtonBlue 
                    text={loading ? "Bezig..." : "Aanmaken"} 
                    disabled={loading} 
                    onClickFunction={addNewGiftcard} 
                    size=""
                />
            </Modal.Footer>
        </Modal>
    );
}

export default GiftcardNewModal;
// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import { useParams } from "react-router";
// import Cookies from "universal-cookie";
// import middleware from "../../Api/Middleware";
// import { useNavigate } from "react-router";
// import PageTemplate from "../../Templates/PageTemplate";
// import { BackButton } from "../../HouseStyle/Components/Buttons";
// import { BorderedDropDown } from "../../HouseStyle/Components/DropDowns.js";
// import ToastError from "../../Toasts/ToastError";
// import ToastSuccess from "../../Toasts/ToastSuccess";
// import { ButtonBlue } from "../../HouseStyle/Components/Buttons";
// import { BorderedTextInput, BorderedMoneyInput, BorderedNumberInput } from "../../HouseStyle/Components/Inputs.js";

// function GiftcardNew() {
//     const navigate = useNavigate();
//     const [salesChannels, setSalesChannels] = useState([])
//     const [status, setStatus] = useState(null);
//     const [cardNumber, setCardNumber] = useState('');
//     const [loadingPage, setLoadingPage] = useState(false);
//     const [statusSwitch, setStatusSwitch] = useState(true);

//     const fetchChannels = async () => {
//         try {
//             const [channels] = await Promise.all([
//                 middleware.get(`saleschannels`)
//             ]);
//             setSalesChannels(channels.data.data);
//         } catch (err) {
//             ToastError('Fout tijdens het ophalen van data');
//         }
//     };
    

//     useEffect( () => {
//         fetchChannels()
//     }, [])

//     const addNewGiftcard = async () => {
//         const cleanCard = cardNumber.replace(/\D/g, '');
//         if (status === null || cleanCard.trim() == '') {
//             ToastError('Vul alle velden in', 'enter_all_field_error');
//             return;
//         }
//         try {
//             await middleware.post(`giftcards`, { 
//                 card_number: cleanCard,
//                 // status: status 
//             });
//             navigate('/algemene/instellingen/cadeaukaarten');
//         } catch (error) {
//             console.error(error);
//             ToastError('Fout bij het aanmaken');
//         }
//     };

//     const formatCardNumber = (num) => {
//         if (!num) return '';
//         const str = num.toString();
//         if (str.length === 13) {
//             return `${str[0]}-${str.slice(1, 7)}-${str.slice(7, 13)}`;
//         }
//         return str.match(/.{1,4}/g)?.join('-') || str;
//     };

//     const handleCardNumberChange = (value) => {
//         const cleanValue = value.replace(/\D/g, '');
//         const limitedValue = cleanValue.slice(0, 13);
//         if (limitedValue.length === 13) {
//             setCardNumber(formatCardNumber(limitedValue));
//         } else {
//             setCardNumber(limitedValue);
//         }
//     };

//     return (
//         <>
//             <PageTemplate navbarTitle={"Cadeaukaarten"} pageIsLoading={loadingPage}>
//                 <div className="w-100 d-flex flex-column">
//                     <div className="w-100 d-flex flex-row mb-3">
//                         <BackButton text={"Terug naar cadeaukaarten"} disabled={false} onClickFunction={() => navigate("/algemene/instellingen/cadeaukaarten")} />
//                     </div>
//                     <div className="whiteBox w-100 py-4">
//                         <div className="w-50 px-3 d-flex flex-column gap-2">
//                             <div className="TableTitle mb-3">Cadeaukaart aanmaken</div>
//                             <BorderedTextInput label="Kaartnummer" inputValue={cardNumber} setInputValue={handleCardNumberChange} placeholder='Kaartnummer' size='m'/>
//                             {/* <BorderedDropDown
//                                 label="Status"
//                                 placeholder=""
//                                 options={[
//                                     { title: "Inactief", value: "0" },
//                                     { title: "Actief", value: "1" },
//                                     { title: "Geblokkeerd", value: "2" },
//                                 ]}
//                                 selectedValue={status}
//                                 setSelectedValue={setStatus}
//                             /> */}
//                             <div className="mt-3">
//                                 <ButtonBlue text={"Aanmaken"} disabled={false} onClickFunction={addNewGiftcard} size=""/>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </PageTemplate>
//         </>
//     )
// }

// export default GiftcardNew;